<template>
  <slot name="header_close" />

  <div class="wrapper_dialog">
    <h3 class="title">
      {{ $t("dialog.refresh_api_key.dialog_title") }}
      <div class="number-block">
        <img class="icon" :src="messengerIcon" />
        <span>{{ number }}</span>
      </div>
    </h3>

    <div class="content">
      <p class="confirm">{{ $t("dialog.refresh_api_key.title") }}</p>

      <div class="action_container">
        <button-loading
          :loading="button.loading"
          :disabled="button.disabled"
          @click="onRefreshApiKey"
        >
          {{ $t("dialog.refresh_api_key.button") }}
        </button-loading>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";
import { useStore } from "vuex";

const store = useStore();

const button = ref({
  loading: false,
  disabled: false,
});

const dialogParams = computed(() => store.state.dialogParams);

const number = computed(() => dialogParams.value?.info?.number);
const messenger = computed(() => dialogParams.value?.info?.messenger);
const messengerIcon = computed(() =>
  messenger.value ? require(`@/assets/icons/${messenger.value}.svg`).default : ""
);

const emits = defineEmits(["refreshApiKey"]);

const onToggleLoadingButton = () => {
  if (button.value.loading) {
    button.value.loading = false;
    button.value.disabled = false;
  } else {
    button.value.loading = true;
    button.value.disabled = true;
  }
};

const onRefreshApiKey = () => {
  const {
    info: { number, messenger, visibility },
  } = dialogParams.value;

  const payload = {
    number,
    messenger,
    visibility,
  };

  onToggleLoadingButton();
  store
    .dispatch("numbers/refreshNumberApiKey", payload)
    .then((res) => {
      if (!!store.getters.getNextDialog) {
        store.commit("setDialog", store.getters.getNextDialog);
        store.commit("setNextDialog", "");
      } else {
        store.commit("closeDialog");
      }
      store.dispatch("numbers/loadNumbersByMessenger", {
        messenger,
        visibility,
      });
      // store.dispatch("numbers/loadConnectedNumbers");
    })
    .catch(() => {
      alert();
      onToggleLoadingButton();
    });
};
</script>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";
</style>
